











































import Vue from 'vue';
import { mapGetters } from 'vuex';
import { ValidationObserver } from 'vee-validate';
import { errorToMessage } from '@/core/utils/errors';
import HMDialog from '@/web/components/common/HMDialog.vue';
export default Vue.extend({
  name: 'MoveCustomersToProduct',
  components: {
    ValidationObserver,
  },
  props: {
    sourceProduct: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectedProduct: null,
      isSaving: false,
    };
  },
  computed: {
    ...mapGetters('product', [
      'teacherProductsExcludeTypePunchCardAndPrivateSpaces',
    ]),
  },
  methods: {
    showConfirmationModal() {
      this.$modal.show(HMDialog, {
        title: this.$t('CUSTOMERS.TITLE.CONFIRM_THE_MOVE'),
        text: this.$t('CUSTOMERS.TEXT.MOVE_CUSTOMERS_TO_PRODUCT_CONFIRMATION', {
          sourceProductName: this.sourceProduct.product_name,
          targetProductName: this.selectedProduct?.product_name,
        }),
        confirmButton: this.$t('GENERAL.BUTTON.CONFIRM'),
        confirm: this.moveCustomersToProduct,
      });
    },
    async moveCustomersToProduct() {
      try {
        this.isSaving = true;
        const dispatchPromise = await this.$store.dispatch(
          'product/moveCustomersToProduct',
          {
            sourceProductId: this.sourceProduct.id,
            targetProductId: this.selectedProduct?.id,
          }
        );
        await this.$store.dispatch('customer-purchases-table/refresh');
        this.$emit('close');
        this.$emit('onSubmit', dispatchPromise);
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$t('CUSTOMERS.NOTIFICATIONS.MOVE_CUSTOMERS_SUCCESS'),
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Moving customers failed',
          text: errorToMessage(error?.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      } finally {
        this.isSaving = false;
      }
    },
  },
  async mounted() {
    await this.$store.dispatch('product/getTeacherProducts');
  },
});
